export const DBaseState = wcardinal.ui.DBaseState;